import { useSelector } from 'react-redux';
import { RootState } from '../slices';

export const useExtraDetailsPageSelector = () =>
  useSelector((state: RootState) => state?.extraDetailsPage);
export const useExtraDetailsContentSelector = () =>
  useSelector((state: RootState) => state?.extraDetailsContent);
